import styled from 'styled-components';
import { Menu, Row, Typography, Layout } from 'antd';

import colors from '../../styles/colors';

const { Item, SubMenu } = Menu;
const { Sider } = Layout;

export const SiderAntd = styled(Sider)`
  pointer-events: ${props => (props.validate ? 'none' : 'auto')};
  background-color: ${colors.primary};
  opacity: ${props => props.validate && 0.8};
  ${props =>
    props.$isPortalMobile &&
    `
      position: fixed;
      inset: 0 auto 0 0;
      z-index: 1001;
      height: 100vh;
      height: 100dvh;
      box-shadow: 8px 0 24px rgba(0, 31, 42, 0.18);

      .ant-layout-sider-zero-width-trigger {
        top: 10px;
        inset-inline-end: -44px;
        width: 44px;
        height: 44px;
        line-height: 44px;
        background: ${colors.primary};
        border-radius: 0 12px 12px 0;
        box-shadow: 5px 3px 14px rgba(0, 31, 42, 0.18);
      }

      & + .ant-layout > .ant-layout-header {
        padding-left: 60px;
      }
    `}
  #subMenuItem:hover {
    & .ant-menu-submenu-arrow {
      color: #fff;
    }
  }

  #subMenuItem {
    & .ant-menu-submenu-arrow {
      color: #fff;
    }
  }

  .ant-menu-item.ant-menu-item-active {
    color: #fff;
  }
  .ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {
    background: ${colors.primary};
    color: #fff;
    font-weight: bold;
    &:after {
      border-inline-end: none;
    }
  }
  .ant-menu-item.ant-menu-item-selected {
    background: ${colors.primary};
    color: #fff;
    font-weight: bold;
    &:after {
      border-inline-end: none;
    }
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: #fff !important;
    font-weight: bold;
  }

  .ant-menu-title-content,
  .ant-menu-item,
  .ant-menu-submenu-title,
  .ant-menu-submenu-arrow {
    color: #fff !important;
  }
  #sair {
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 10px;
    background: transparent;
    cursor: default;
    width: 80px;
    min-width: 80px;
    padding-right: 0;
    &:after {
      content: '';
      border-right: none;
    }
  }
  #sairTexto {
    color: #fff;
    filter: grayscale(0.06);
    cursor: pointer;
    margin: 0;
  }
  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border: none;
  }

  .ant-menu-inline-collapsed {
    > .ant-menu-item,
    > .ant-menu-submenu > .ant-menu-submenu-title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-inline: 0 !important;
    }

    .ant-menu-item-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      min-width: 24px;
      margin: 0 !important;
      overflow: visible;
    }

    .ant-menu-title-content,
    .ant-menu-submenu-arrow {
      display: none;
    }
  }
`;

export const ItemMenuCustom = styled(Item)`
  background-color: ${colors.primary} !important;
  color: #fff;
  margin: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &.ant-menu-item-selected .anticon {
    color: #ade84f;
  }

  span {
    color: #fff;
  }
`;

export const SubMenuCustom = styled(SubMenu)`
  background-color: ${colors.primary} !important;
  margin: 0 !important;

  .ant-menu-submenu-title {
    margin: 0 !important;
  }

  &.ant-menu-submenu-open .ant-menu-submenu-title .anticon {
    color: #ade84f;
  }

  .ant-menu-title-content {
    color: #fff;
    margin-left: 15px;
  }

  & {
    .ant-menu-submenu-open {
      color: ${colors.verde} !important;
    }
  }
`;

export const SubItemMenuCustom = styled(Item)`
  background-color: ${colors.primaryShade} !important;
  color: #fff;
  margin: 0 !important;

  &.ant-menu-item-selected .anticon {
    color: #ade84f;
  }
`;

export const ContainerLogo = styled(Row)`
  display: flex;
  justify-content: center;
  height: 70px;
  align-items: center;
`;

export const ItemMenuEnfeite = styled.div`
  display: none;

  height: 40px;
  width: 5px;
  background-color: #ade84f;
  position: absolute;
  top: 0;
  right: 0;
`;

export const DividerText = styled(Typography.Text)`
  color: rgba(255, 255, 255, 0.6);
  align-items: center;

  display: ${props => {
    if (props.iscollapsed === 'true') return 'flex';
    return 'initial';
  }};

  justify-content: ${props => {
    if (props.iscollapsed === 'true') return 'center';
    return 'initial';
  }};

  margin-left: ${props => {
    if (props.iscollapsed === 'true') return 0;
    return '10px';
  }};
`;
